import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { PageHeader, Loading } from "@/components/Common";
import { EUR, EURc, pnlColor } from "@/lib/format";
import api from "@/lib/api";

export default function SessionAnalysis() {
  const { data, isLoading } = useQuery({ queryKey: ["sessions"], queryFn: () => api.get("/sessions").then((r) => r.data) });
  if (isLoading || !data) return <Loading />;
  const sessions = data.sessions || [];

  return (
    <div data-testid="sessions-page">
      <PageHeader title="Session Analysis" subtitle="Asian · London · New York · London/NY Overlap" />
      <div className="grid gap-5 sm:grid-cols-2">
        {sessions.map((s, i) => (
          <motion.div key={s.key} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
            className="dlx-card dlx-grain p-6" data-testid={`session-card-${s.key.replace(/[^a-z]/gi, "")}`}>
            <div className="flex items-center justify-between">
              <span className="font-serif text-xl text-white">{s.key}</span>
              <span className={`font-mono text-lg font-bold ${pnlColor(s.net_pnl)}`}>{EURc(s.net_pnl)}</span>
            </div>
            <div className="mt-5 grid grid-cols-3 gap-3">
              {[
                { l: "Trade", v: s.trade_count },
                { l: "Win Rate", v: `${s.win_rate}%` },
                { l: "Expectancy", v: EUR(s.expectancy) },
                { l: "Avg Win", v: EUR(s.avg_win), tone: "profit" },
                { l: "Avg Loss", v: EUR(s.avg_loss), tone: "loss" },
                { l: "Durata Media", v: `${s.avg_duration_min}m` },
              ].map((t) => (
                <div key={t.l}>
                  <div className="font-sans text-[9px] uppercase tracking-widest text-zinc-500">{t.l}</div>
                  <div className={`mt-1 font-mono text-sm ${t.tone === "profit" ? "text-profit" : t.tone === "loss" ? "text-loss" : "text-white"}`}>{t.v}</div>
                </div>
              ))}
            </div>
            <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-white/5">
              <div className="h-full rounded-full" style={{ width: `${s.win_rate}%`, background: "linear-gradient(90deg,#997A15,#D4AF37)" }} />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
